import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_111: FaireProductEntity = {
  token: "legacy_prod_abbott-111",
  type: "product",
  name: 'Mini Low Pumpkin Planter 4" W',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/d6079cc2831ce2dec8d5da8f2b9f402732cce65a90c44e3c4c03f05881731dc8.jpeg",
  priceDollars: 16,
  subcategory: "Planters",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_garden-outdoor"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
